// extracted by mini-css-extract-plugin
export var active = "_dn-2";
export var recordingDot = "_dn-1";
export var recordingIndicator = "_dn-0";